import { render, staticRenderFns } from "./DeviceSettingDialog2.vue?vue&type=template&id=045d2210&scoped=true"
import script from "./DeviceSettingDialog2.vue?vue&type=script&lang=js"
export * from "./DeviceSettingDialog2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "045d2210",
  null
  
)

export default component.exports